import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, Dropdown, MenuProps } from "antd";
import InlineSvg from "react-inlinesvg";

import countryLangStore from "@zustand/countryLang";
import { icons } from "@constants/icons";
import { Get } from "@api/apiAxios";
import { ILang, ISetMasterLanguage } from "@interface/ICountry";
import { colors } from "@constants/colors";

const Language = () => {
  const { i18n } = useTranslation();
  const { lang, setLang, country } = countryLangStore();
  const [items, setItems] = useState<MenuProps["items"]>([]);
  const [fullNameLang, setFullNameLang] = useState<string>("");

  const isTH = country?.country === "th";

  const switchingLanguage = (short: string) => {
    i18n.changeLanguage(short);
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  useEffect(() => {
    getLanguageMaster();
  }, [lang]);

  const getLanguageMaster = async () => {
    const res = await Get({ urlPath: "/master/master-language", headers: {} });
    const { status, message } = res;
    if (status) {
      const setLanguage = message.map((val: ILang) => {
        return {
          key: val.language_key,
          label: val.full_name,
        };
      });
      const defaultFullName = setLanguage.find(
        (val: ISetMasterLanguage) => val.key.toString() === lang.toString()
      )?.label;

      setFullNameLang(defaultFullName ?? "English");
      setItems(setLanguage);
    }
  };

  const handleMenuClick: MenuProps["onClick"] = (e: any) => {
    switchingLanguage(e.key);
    setLang(e.key);
    setFullNameLang(e?.domEvent?.target?.innerText);
  };

  return (
    <Content data-testid="dropdown">
      <Dropdown
        trigger={["click"]}
        menu={{ items, onClick: handleMenuClick }}
        disabled={isTH}
      >
        <Button
          onClick={(e) => e.preventDefault()}
          className={`btn-lang ${isTH ? "disable" : ""}`}
        >
          <InlineSvg src={icons.language} />
          {fullNameLang}
        </Button>
      </Dropdown>
    </Content>
  );
};

export default Language;

const Content = styled.div`
  width: fit-content;
  margin: 0 5px;
  .btn-lang {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .disable {
    svg {
      width: 20px;
      height: 20px;
      margin: 0 10px 0 0;
      path {
        fill: ${colors?.gray9d9};
      }
    }
  }
  svg {
    width: 20px;
    height: 20px;
    margin: 0 10px 0 0;
  }
`;
